import type { SearchBoxFeatureSuggestion } from '@mapbox/search-js-core';

/** The address a search result resolved to, in the lines the backend stores it in. */
export interface AddressLines {
  address: string;
  street: string;
  postcode: string;
  city: string;
  country_code: string;
}

/**
 * Read the address lines off a Search Box result. Sending them with the coordinates is what spares
 * the backend a second lookup of the address the user already picked.
 *
 * Answers null for a pasted coordinate pair, which carries no address at all — the backend then
 * resolves the address from the point, as it does for a dropped pin. A result missing any one line
 * has the same effect: the backend treats a partial address as one to resolve.
 */
export function featureAddressLines(
  value: SearchBoxFeatureSuggestion | unknown,
): AddressLines | null {
  const properties = (value as SearchBoxFeatureSuggestion)?.properties;
  if (properties?.full_address == null) return null;

  const context = properties.context;
  return {
    address: properties.full_address,
    street: context?.address?.name ?? '',
    postcode: context?.postcode?.name ?? '',
    city: context?.place?.name ?? '',
    country_code: context?.country?.country_code?.toUpperCase() ?? '',
  };
}
